import axios from 'lib/axios';

const getProfile = async () => {
  const { data } = await axios.get('/admin/me');
  return data;
};

export { getProfile };
